export default function H2(props) {
  return (
    <div className={`mt-10 mb-5 ${props.titleClassName || ''}`}>
      <h2 className="text-2xl font-semibold tracking-tight text-gray-900">
        {props.title}
      </h2>
      {props.subtitle &&
        <span className={`block text-sm text-gray-500 mt-1 ${props.subtitleClassName || ''}`}>{props.subtitle}</span>
      }
      {props.children}
    </div>
  )
}
